import { Directive, HostListener, Input, OnDestroy, ViewContainerRef } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { GridExtender } from './Grid.extender';
import { EnumGridModes } from '@core/framework/sysenums.enum';
import { IBaseComponent } from './../component/IBaseComponent';
import { IGridComponent } from '../component/BaseGridComponent';

@Directive({ selector: '[configGrid]' })
export class M4UConfigGridDirective implements OnDestroy {
    //Set default options
    private grid: DxDataGridComponent;
    public get gridAny(): any { return this.grid; }
    // @ts-ignore
    constructor(private c: DxDataGridComponent) {
        this.grid = c;
    }

    //Set name (no instance yet), set directly
    private _Component: IBaseComponent
    get Component(): IBaseComponent { return this._Component; }
    @Input() set Component(value: IBaseComponent) {
        this._Component = value;
        this.InitExtender();
    }

    //Initialize - should be only called once
    private _Mode: EnumGridModes;
    get Mode(): EnumGridModes { return this._Mode; }
    @Input() set Mode(value: EnumGridModes) {
        this._Mode = value;
        this.InitExtender();
    }

    private _AllowCustomization: boolean = false;
    get AllowCustomization(): boolean { return this._AllowCustomization; }
    @Input() set AllowCustomization(value: boolean) {
        this._AllowCustomization = value;
        this.InitExtender();
    }

    private _AllowAdvancedFilters: boolean = false;
    get AllowAdvancedFilters(): boolean { return this._AllowAdvancedFilters; }
    @Input() set AllowAdvancedFilters(value: boolean) {
        this._AllowAdvancedFilters = value;
        this.InitExtender();
    }

    private _Name: string;
    get Name(): string { return this._Name; }
    @Input() set Name(name: string) {
        this._Name = name;
        this.gridAny.Name = this._Name;
    }

    private _entityTypeName: string;
    @Input() set EntityTypeName(value: string) {
        this._entityTypeName = value;
        this.InitExtender();
    }
    get EntityTypeName() { return this._entityTypeName; }

    //Perform initialization once all mandatory properties are set
    private InitExtender() {
        if (this.Mode == undefined || this.Component == undefined || this.AllowCustomization == undefined || this.AllowAdvancedFilters == undefined) return;
        this.gridAny.G = new GridExtender(this.grid, this.Mode, this.AllowCustomization, this.AllowAdvancedFilters, this.Component, this.EntityTypeName);
        this.gridAny.G.InitGrid();
    }

    private get G(): GridExtender { return this.gridAny.G; }

    //Create new row when no rows exist
    @HostListener('click', ['$event'])
    onClick() {
        this.G.OnGridClick();
    }

    //Clean up
    ngOnDestroy() {
        this.G && this.G.DestroyGrid();
    }

}

//use this directive to get descendants grid from custom components
@Directive({
    selector: '[gridWrapper]'
})
export class GridWrapperDirective {
    constructor(private vcRef: ViewContainerRef) { }

    public get G(): GridExtender {
        const component = <IGridComponent>this.vcRef["_data"].componentView.component;

        return component.G;
    }
}
